module.exports = __webpack_public_path__ + "img/Competitionleft3.6db523cd.png";